<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { componentStore } from "@common/componentStore/componentStore";
import { library } from "@common/library/library";
import { configStore } from "@common/configStore";
import { ddStore } from "@common/ddStore";
import { actionStore } from "@common/actionStore";

let vmsChangeUserInformationConfig = {
    cId: "vmsChangeUserInformation",
    cType: "vmsChangeUserInformation",
    cTitle: "Change User Information",
    cTemplate: `<div :id="wrapperID" class="vmsChangeUserInformation-wrapper" :class="{'is-from-popup': isFromPopup}">
                    <div class="vmsChangeUserInformation-title">Change User Information</div>
                    <div class="vmsChangeUserInformation-instruction">
                        You must enter the old password to change user information or password. Your user ID and password must contain at least 6 characters.
                    </div>
                    <div class="vmsChangeUserInformation-fieldsWrapper">
                        <div class="vmsChangeUserInformation-field">
                            <div class="fieldLabel"><span>Your Name:</span></div>
                            <div class="fieldControl">
                                <control name="CHANGE_USER_INFORMATION_USER_NAME" :required="true"></control>
                            </div>
                        </div>
                        <div class="vmsChangeUserInformation-field">
                            <div class="fieldLabel"><span>Your Email:</span></div>
                            <div class="fieldControl">
                                <control name="CHANGE_USER_INFORMATION_USER_EMAIL"></control>
                            </div>
                        </div>
                        <div class="vmsChangeUserInformation-field">
                            <div class="fieldLabel"><span>Your Phone:</span></div>
                            <div class="fieldControl">
                                <control name="CHANGE_USER_INFORMATION_USER_PHONE"></control>
                            </div>
                        </div>
                        <div class="vmsChangeUserInformation-field">
                            <div class="fieldLabel"><span>Your Cell Phone:</span></div>
                            <div class="fieldControl">
                                <control name="CHANGE_USER_INFORMATION_USER_CELL_PHONE"></control>
                            </div>
                        </div>
                        <div class="vmsChangeUserInformation-field">
                            <div class="fieldLabel"><span>User ID:</span></div>
                            <div class="fieldControl">
                                <control name="CHANGE_USER_INFORMATION_USER_ID" :required="true"></control>
                            </div>
                        </div>
                        <div class="vmsChangeUserInformation-field">
                            <div class="fieldLabel"><span>Current Password:</span></div>
                            <div class="fieldControl">
                                <control name="CHANGE_USER_INFORMATION_USER_PASSWORD" :required="true"></control>
                            </div>
                        </div>
                        <div v-if="typeof mfaData === 'object' && mfaData" class="vmsChangeUserInformation-field">
                            <div class="fieldLabel"><span>MFA Key:</span></div>
                            <div class="fieldControl">
                                <div class="mfaKey">{{mfaData.key}}</div>
                                <div class="mfaKeyInfo">
                                    <Icon name="info" @click="openSetupMFA"></Icon>
                                </div>
                            </div>
                        </div>
                        <div class="vmsChangeUserInformation-field __alignBaseline">
                            <div class="fieldLabel"><span>Time Zone:</span></div>
                            <div class="fieldControl">
                                <control name="CHANGE_USER_INFORMATION_USER_TIMEZONE" :disabled="this.controls['CHANGE_USER_INFORMATION_USER_TIME_ZONE_BROWSER'].value === true" :items="timezoneList"></control>
                                <div class="vmsChangeUserInformation-localTime">
                                    Current time for selected timezone is {{getTimezoneCurrentTime()}}
                                </div>
                                <control name="CHANGE_USER_INFORMATION_USER_TIME_ZONE_BROWSER"></control>

                            </div>
                        </div>
                        <div v-if="roleName" class="vmsChangeUserInformation-basedRoleName">
                            *user based on the {{roleName}} role
                        </div>
                        <hr class="vmsChangeUserInformation-changePassword">
                        <div>
                            <h3>If you need to change your password</h3>
                            <div>
                                <div class="vmsChangeUserInformation-field">
                                    <div class="fieldLabel"><span>New Password:</span></div>
                                    <div class="fieldControl">
                                        <control name="CHANGE_USER_INFORMATION_USER_NEW_PASSWORD" @keyup="checkPassword()"></control>
                                    </div>
                                </div>
                                <div class="vmsChangeUserInformation-field">
                                    <div class="fieldLabel"><span>Confirm New Password:</span></div>
                                    <div class="fieldControl">
                                        <control name="CHANGE_USER_INFORMATION_USER_NEW_PASSWORD_CONFIRM"></control>
                                    </div>
                                </div>
                                <div v-if="typeof newPasswordStrength === 'object' && newPasswordStrength">
                                    <span :style="'color: ' + newPasswordStrength.color">Your password is of {{newPasswordStrength.text}} complexity.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="vmsChangeUserInformation-buttons">
                        <div class="vmsChangeUserInformation-button"><control name="CHANGE_USER_INFORMATION_OK_BUTTON"></control></div>
                        <div class="vmsChangeUserInformation-button"><control name="CHANGE_USER_INFORMATION_CANCEL_BUTTON"></control></div>
                    </div>
               </div>
               `,
    controls: [
        {
            name: 'CHANGE_USER_INFORMATION_USER_NAME',
            type: 'string',
            hideMessage: true,
            fields: { text: 'text', value: 'value' },
            ref: 'vmsChangeUserInformationUserName'
        },
        {
            name: 'CHANGE_USER_INFORMATION_USER_EMAIL',
            type: 'string',
            hideMessage: true,
            fields: { text: 'text', value: 'value' },
            ref: 'vmsChangeUserInformationUserEmail'
        },
        {
            name: 'CHANGE_USER_INFORMATION_USER_PHONE',
            type: 'string',
            hideMessage: true,
            fields: { text: 'text', value: 'value' },
            ref: 'vmsChangeUserInformationUserPhone'
        },
        {
            name: 'CHANGE_USER_INFORMATION_USER_CELL_PHONE',
            type: 'string',
            hideMessage: true,
            fields: { text: 'text', value: 'value' },
            ref: 'vmsChangeUserInformationUserCellPhone'
        },
        {
            name: 'CHANGE_USER_INFORMATION_USER_ID',
            type: 'string',
            hideMessage: true,
            fields: { text: 'text', value: 'value' },
            ref: 'vmsChangeUserInformationUserID'
        },
        {
            name: 'CHANGE_USER_INFORMATION_USER_PASSWORD',
            type: 'password',
            hideMessage: true,
            fields: { text: 'text', value: 'value' },
            ref: 'vmsChangeUserInformationUserPassword'
        },
        {
            name: 'CHANGE_USER_INFORMATION_USER_TIMEZONE',
            type: 'dropdown',
            hideMessage: true,
            showClearButton: false,
            fields: { text: 'text', value: 'value' },
            ref: 'vmsChangeUserInformationUserTimeZone'
        },
        {
            name: 'CHANGE_USER_INFORMATION_USER_TIME_ZONE_BROWSER',
            type: 'checkbox',
            label: 'use browser\'s',
            ref: 'vmsChangeUserInformationUserTimeZoneBrowser'
        },
        {
            name: 'CHANGE_USER_INFORMATION_USER_NEW_PASSWORD',
            type: 'password',
            hideMessage: true,
            fields: { text: 'text', value: 'value' },
            ref: 'vmsChangeUserInformationUserNewPassword'
        },
        {
            name: 'CHANGE_USER_INFORMATION_USER_NEW_PASSWORD_CONFIRM',
            type: 'password',
            hideMessage: true,
            fields: { text: 'text', value: 'value' },
            ref: 'vmsChangeUserInformationUserNewPasswordConfirm'
        },
        {
            name: 'CHANGE_USER_INFORMATION_OK_BUTTON',
            type: 'button',
            label: 'OK',
            onclick: 'save'
        },
        {
            name: 'CHANGE_USER_INFORMATION_CANCEL_BUTTON',
            type: 'button',
            label: 'Cancel',
            onclick: 'close'
        },
    ]
};

let vmsChangeUserInformationCmp = {
    name: 'vmsChangeUserInformation',
    preInitControls: true,
    props: {
        isFromPopup: {
            default: false
        }
    },
    data() {
        return {
            newPasswordStrength: null,
            roleName: null,
            mfaData: null,
            timezoneList: [],
            accountTimeFormat: null,
            accountPhoneFormat: null
        };
    },
    computed: {
        wrapperID() {
            return this.cId + 'Wrapper';
        }
    },
    components: {
        labelWrapper: defineAsyncComponent(() => import('@common/control/labelWrapper'))
    },
    mounted() {
    },
    methods: {
        onLoad() {
            this.$emit('update:vmsChangeUserInformationLoaded', true);
            library.showLoadingIndicator(this.wrapperID);
            let userDataLoaded = false;
            let timezoneListLoaded = false;
            this.sDs.post('ec_getUserDataForChangeInfo').then((response) => {
                if (response && response.status === 'success' && response.data) {
                    if (typeof response.data.CLIENT_NAME !== 'undefined') {
                        this.refs['vmsChangeUserInformationUserName'].value = response.data.CLIENT_NAME;
                    }
                    if (typeof response.data.CLIENT_EMAIL !== 'undefined') {
                        this.refs['vmsChangeUserInformationUserEmail'].value = response.data.CLIENT_EMAIL;
                    }
                    if (typeof response.data.CLIENT_PHONE !== 'undefined') {
                        this.refs['vmsChangeUserInformationUserPhone'].value = response.data.CLIENT_PHONE;
                    }
                    if (typeof response.data.CLIENT_CELL_PHONE !== 'undefined') {
                        this.refs['vmsChangeUserInformationUserCellPhone'].value = response.data.CLIENT_CELL_PHONE;
                    }
                    if (typeof response.data.CLIENT_USER_NAME !== 'undefined') {
                        this.refs['vmsChangeUserInformationUserID'].value = response.data.CLIENT_USER_NAME;
                    }
                    if (typeof response.data.CLIENT_MFA === 'object' && response.data.CLIENT_MFA) {
                        this.mfaData = library.cloneObj(response.data.CLIENT_MFA);
                    }
                    if (typeof response.data.CLIENT_TIME_ZONE !== 'undefined') {
                        this.controls['CHANGE_USER_INFORMATION_USER_TIMEZONE'].value = response.data.CLIENT_TIME_ZONE;
                    }
                    if (typeof response.data.CLIENT_TIME_ZONE_BROWSER === 'boolean') {
                        this.controls['CHANGE_USER_INFORMATION_USER_TIME_ZONE_BROWSER'].value = response.data.CLIENT_TIME_ZONE_BROWSER;
                    }
                    if (typeof response.data.CLIENT_ROLE_NAME !== 'undefined') {
                        this.roleName = response.data.CLIENT_ROLE_NAME;
                    }
                }
                userDataLoaded = true;
                if (userDataLoaded && timezoneListLoaded) {
                    library.hideLoadingIndicator(this.wrapperID);
                }
            });
            this.sDs.post('sds_getTimezoneList').then((response) => {
                if (response && response.status === 'success' && typeof response.data === 'object' && response.data) {
                    let tmpTimezoneList = [];
                    if (response.data.length) {
                        response.data.forEach((item) => {
                            tmpTimezoneList.push({
                                text: item.timezoneTitle,
                                value: item.timezoneId
                            });
                        });
                    }
                    this.timezoneList = library.cloneObj(tmpTimezoneList);
                }
                timezoneListLoaded = true;
                if (userDataLoaded && timezoneListLoaded) {
                    library.hideLoadingIndicator(this.wrapperID);
                }
            });
            configStore.getAccountSettings().then((accountSettings) => {
                if (typeof accountSettings !== 'object') {
                    return;
                }
                if (typeof accountSettings['ACCOUNT_TIME_FORMAT'] !== 'undefined' && accountSettings['ACCOUNT_TIME_FORMAT']) {
                    this.accountTimeFormat = accountSettings['ACCOUNT_TIME_FORMAT'];
                }
                if (typeof accountSettings['ACCOUNT_PHONE_FORMAT'] === 'string' && accountSettings['ACCOUNT_PHONE_FORMAT']) {
                    this.accountPhoneFormat = accountSettings['ACCOUNT_PHONE_FORMAT'].replaceAll('%s', '#');
                }
            });
        },
        getTimezoneCurrentTime() {
            let currentTZ = this.controls['CHANGE_USER_INFORMATION_USER_TIMEZONE'].value ?? 0;
            if (currentTZ < -100) {
                currentTZ += 100;
            }
            let is12HourFormat = this.accountTimeFormat === 'g:i A';
            let nowDate = new Date();
            let utc = nowDate.getTime() + (nowDate.getTimezoneOffset() * 60000);
            let timezoneDate = new Date(utc + (3600000 * currentTZ));
            let hours = timezoneDate.getHours();
            let minutes = String(timezoneDate.getMinutes()).padStart(2, '0');
            let amPm = '';
            if (is12HourFormat) {
                amPm = hours >= 12 ? 'PM' : 'AM';
                hours = hours % 12 || 12;
            }
            hours = String(hours).padStart(2, '0');
            return `${hours}:${minutes}${amPm ? ` ${amPm}` : ''}`;
        },
        checkPasswordStrength() {
            let newPassword = this.refs['vmsChangeUserInformationUserNewPassword']?.value;
            if (typeof newPassword === 'undefined' || newPassword === '') {
                return null;
            }
            let score = -1;
            if (newPassword.length >= 8) score++;
            if (/[A-Z]/.test(newPassword)) score++;
            if (/[a-z]/.test(newPassword)) score++;
            if (/\d/.test(newPassword)) score++;
            if (/[!@#$%^&*(),.?":{}|<>]/.test(newPassword)) score++;
            return [
                {
                    text: 'very weak',
                    color: '#FF5757FF'
                },
                {
                    text: 'weak',
                    color: '#FF5757FF'
                },
                {
                    text: 'medium',
                    color: '#D79E48FF'
                },
                {
                    text: 'high',
                    color: '#54C751FF'
                },
                {
                    text: 'very high',
                    color: '#54C751FF'
                }
            ][score < 0 ? 0 : score];
        },
        checkPassword() {
            this.newPasswordStrength = this.checkPasswordStrength();
        },
        openSetupMFA() {
            if (typeof this.mfaData === 'object' && this.mfaData) {
                actionStore.openSetupMFA(this.mfaData.key, this.mfaData.qrCode);
            }
        },
        async save() {
            let userName = this.refs['vmsChangeUserInformationUserName'].value.trim();
            let userEmail = this.refs['vmsChangeUserInformationUserEmail'].value.trim();
            let userPhone = this.refs['vmsChangeUserInformationUserPhone'].value.trim();
            let userCellPhone = this.refs['vmsChangeUserInformationUserCellPhone'].value.trim();
            let userID = this.refs['vmsChangeUserInformationUserID'].value.trim();
            let currentPassword = this.refs['vmsChangeUserInformationUserPassword'].value.trim();
            let newPassword = this.refs['vmsChangeUserInformationUserNewPassword'].value.trim();
            let newPasswordConfirm = this.refs['vmsChangeUserInformationUserNewPasswordConfirm'].value.trim();
            let userTimezone = this.controls['CHANGE_USER_INFORMATION_USER_TIMEZONE'].value;
            let isTimezoneBrowser = this.controls['CHANGE_USER_INFORMATION_USER_TIME_ZONE_BROWSER'].value;
            let browserTimezone = new Date().getTimezoneOffset() / -60;
            let title = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_TITLE');
            let message = '';
            if (userEmail && !library.checkEmail(userEmail)) {
                message = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_EMAIL_NOT_VALID', userEmail);
            } else if (userPhone.length && this.accountPhoneFormat && !library.checkPhone(userPhone, this.accountPhoneFormat)) {
                message = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_PHONE_NOT_VALID', userPhone, this.accountPhoneFormat);
            } else if (userCellPhone.length && this.accountPhoneFormat && !library.checkPhone(userCellPhone, this.accountPhoneFormat)) {
                message = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_PHONE_NOT_VALID', userCellPhone, this.accountPhoneFormat);
            } else if (userName && userName.search(/sign.*in/i) !== -1) {
                message = await ddStore.getAlias('COMMON', 'CLIENT_NAME') + ' ' + await ddStore.getAlias('COMMON', 'ERRORMESSAGE_WRONG');
            } else if (!userID) {
                message = await ddStore.getAlias('COMMON', 'CLIENT_USER_NAME') + ' ' + await ddStore.getAlias('COMMON', 'ERRORMESSAGE_EMPTY');
            } else if (userID.length < ((typeof THE_CUSTOMER !== 'undefined' && (THE_CUSTOMER === 'OCPS' || THE_CUSTOMER === 'OCPSQA')) ? 3 : 6)) {
                message = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_USERID_LENGTH');
            } else if (userID.search(/^[A-Za-z0-9 _\-@.]+$/) === -1) {
                message = await ddStore.getAlias('COMMON', 'CLIENT_USER_NAME') + ' ' + await ddStore.getAlias('COMMON', 'ERRORMESSAGE_WRONG');
            } else if ((newPassword.length || newPasswordConfirm.length) && (newPassword !== newPasswordConfirm)) {
                message = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_PASSWORD_VERIFY');
                this.refs['vmsChangeUserInformationUserNewPassword'].value = '';
                this.refs['vmsChangeUserInformationUserNewPasswordConfirm'].value = '';
            } else {
                this.sDs.post(
                    'ec_changeUserInformation',
                    userName,
                    userEmail,
                    userPhone,
                    userCellPhone,
                    userID,
                    userTimezone,
                    isTimezoneBrowser,
                    browserTimezone,
                    currentPassword,
                    newPassword,
                    newPasswordConfirm
                ).then((response) => {
                    if (response && response.status === 'success') {
                        library.removeSessionStorage('ecUserField');
                        library.removeSessionStorage('ecUserProperty');
                        setTimeout(() => {
                            location.reload();
                        }, 500);
                        this.close();
                    } else if (typeof response.error === 'object' && response.error.length) {
                        library.showDialog(response.error[0], false, false, {
                            title: title, name: 'vmsChangeUserInformationSaveWarning', preventCloseOnBackdropClick: true, showAsAlert: true
                        });
                    }
                });
            }
            if (message) {
                let title = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_TITLE');
                await library.showDialog(message, false, false, {
                    title: title, name: 'vmsChangeUserInformationSaveWarning', preventCloseOnBackdropClick: true, showAsAlert: true
                });
            }
        },
        close() {
            if (/openvmsChangeUserInformation/g.test(window.name)) {
                window.close();
            } else {
                if (this.$parent && this.$parent.$parent && this.$parent.$parent.$parent && this.$parent.$parent.$parent.componentDialogs && this.$parent.$parent.$parent.componentDialogs[0] && this.$parent.$parent.$parent.componentDialogs[0].cancelButton) {
                    this.$parent.$parent.$parent.componentDialogs[0].cancelButton.click();
                }
            }
        }
    }
};

componentStore.initComponent(vmsChangeUserInformationCmp, vmsChangeUserInformationConfig);
export { vmsChangeUserInformationConfig, vmsChangeUserInformationCmp };
export default vmsChangeUserInformationCmp;
</script>

<style>
#dialog_container_openvmsChangeUserInformation, #dialog_container_openvmsChangeUserInformation > div {
    height: 400px;
}
.vmsChangeUserInformation-title {
    font-size: 24px;
    font-weight: 600;
    text-align: center;
    color: #41362f;
}
.vmsChangeUserInformation-instruction {
    text-align: center;
    margin-top: 10px;
}
.vmsChangeUserInformation-fieldsWrapper {
    margin-top: 20px;
    width: 100%;
}
.vmsChangeUserInformation-field {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
}
.vmsChangeUserInformation-field.__alignBaseline {
    align-items: baseline;
}
.vmsChangeUserInformation-field .fieldLabel {
    width: 170px;
    font-size: 15px !important;
    font-family: "Roboto", "Segoe UI", "GeezaPro", "DejaVu Serif", "sans-serif", "-apple-system", "BlinkMacSystemFont" !important;
    font-weight: 500 !important;
}
.vmsChangeUserInformation-field .fieldControl {
    width: calc(100% - 170px);
}
.vmsChangeUserInformation-field .mfaKey {
    float: left;
}
.vmsChangeUserInformation-field .mfaKeyInfo {
    float: left;
    margin-left: 5px;
    cursor: pointer;
}
.vmsChangeUserInformation-localTime {
    margin: 10px 0;
}
.vmsChangeUserInformation-basedRoleName {
    margin-top: 10px;
    font-size: 15px;
    font-weight: bold;
}
.vmsChangeUserInformation-changePassword {
    margin: 20px 0;
}
</style>
<style scoped>
:deep(.vmsChangeUserInformation-wrapper) {
    width: 100%;
    height: 400px;
    background-color: #fff;
    padding: 20px;
}
:deep(.is-from-popup) {
    width: 100%;
    height: 100%;
}
:deep(.vmsChangeUserInformation-buttons) {
    text-align: center;
    margin-top: 40px;
    clear: both;
}
:deep(.vmsChangeUserInformation-button) {
    display: inline-block;
    margin-left: 20px;
    width: 90px;
}
</style>
